import { render } from "./SmartEditor.vue?vue&type=template&id=11a0879c"
import script from "./SmartEditor.vue?vue&type=script&lang=js"
export * from "./SmartEditor.vue?vue&type=script&lang=js"

import "./SmartEditor.vue?vue&type=style&index=0&id=11a0879c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__